<template>
  <div class="tagSelectComponent">
  <!-- {{choseIdArr}} -->
  <!-- ;{{choseIdArr}} -->
    <!-- <div> {{tagWord}}    {{value}}{{type}} {{choseIdArr}}</div> -->
    <div class="inlineBlock" v-if="!showAreaValue" >
      <div class="tagOneItem" v-for="(list,index) in tagWord" :class="{active:choseIdArr.indexOf(list.tag_id)>=0}" @click="toggleItem(list.tag_id)">
        <img :src="IMG_PREV+list.tag_icon" alt="">
        <span class="imgDes"> {{list.tag_name}};{{list.tag_id}}</span>
      </div>
    </div>
    <div class="inlineBlock" v-if="showAreaValue=='name'" >
      <div  class="nameSpan" v-for="(list,index) in tagWord" v-if="choseIdArr.indexOf(list.tag_id)>=0">{{list.tag_name}}</div>
    </div>
    <div class="inlineBlock detail" v-if="showAreaValue=='detail'" >
      <div class="tagOneItem" v-for="(list,index) in tagWord" v-show="choseIdArr.indexOf(list.tag_id)>=0">
        <img :src="IMG_PREV+list.tag_icon" alt="">
        <span class="imgDes"> {{list.tag_name}}</span>
      </div>
    </div>
   <!-- <div>
      {{choseIdArr}}
    </div> -->
  </div>

</template>

<script>
	import {	utils	} from '@/common/common.js'
	import { ajaxPost ,api} from '@/common/request.js'
	export default {
		name: 'authmodal',
		data() {
			return {
        // data_park:[],
        // data_item:[],
        // data_store:[],
        // data_map:[],
        tagWord:[],
        choseIdArr:[],
        showAreaValue:'',


			}
		},
		props:['type','value','showArea','num'],
		components: {},
    watch:{
      showArea:{
        handler: function (val, oldVal) {
          this.showAreaValue=val
        },
        immediate: true
      },
      value:{
        handler: function (val, oldVal) {

          // console.log(1)
          // console.log(val)
          if(val&&val.length>0){
            this.choseIdArr=val.split(",")
          }else{
            this.choseIdArr=[]
          }
          this.getList(this.type)
          // console.log(this.choseIdArr)
        },
        immediate: true
      },
      type:{
        handler: function (val, oldVal) {
          // console.log("检测到标签部组件 type 变化+"+val)

        },
        immediate: true
      },
    },
		computed: {
      adminId() {
        return utils.getAdminId()
      },
      IMG_PREV(){
      	return api.imgPrev
      },
      api(){
        return api
      },
		},
		methods: {
      toggleItem(itemId){
        if(this.num==1){
          this.choseIdArr=[itemId]
          // this.choseIdArr.push()
        }else{
          let index=this.choseIdArr.indexOf(itemId)
          if(index>=0){
            this.choseIdArr.splice(index,1)
          }else{
            this.choseIdArr.push(itemId)
          }
        }

        // alert("触发emit")
        this.$emit('clickItem',this.choseIdArr);
      },
			getList(type){
			  let _this=this
			  // alert(type)
			  let arg={tagType:type}
			  ajaxPost('/tag/tagList', arg).then(function(res) {
			    if(res.errorCode==200){
            _this.tagWord=res.data
            console.log(_this.tagWord)
          // _this.tagWord=[{tag_id:6},{tag_id:2},{tag_id:4}],
          // _this.choseIdArr=[1,2,3]
          var idWord=_this.tagWord.map(function(item,index){
            return item.tag_id
          })
          console.log(idWord,"11111111111---idWord")
          _this.choseIdArr.forEach(function(item,index){
            console.log("循环choseIdArr 1次")
            if(idWord.indexOf(item)>=0){

            }else{
              console.log(item+'不存在1，删除index='+index)
              _this.choseIdArr.splice(index,1)
            }
          })
          console.log(_this.choseIdArr,"2222222222222----_this.choseIdArr")
            // _this.newChoseIdArr=_this.tagWord.filter((item) => {
            //    if (_this.choseIdArr.indexOf(item.tag_id) > 0) {
            //       return true
            //    } else {
            //      return false
            //    }
            // }).map((item) => item.tag_id)

			    }else{

			    }
			  }, function(res) {})
			},
		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
  .tagSelectComponent{

    .tagOneItem{border:1px solid #aaa;box-shadow: 0 0 4px #eee;padding:5px;display: inline-block;margin-bottom: 10px;
     background: #fff;; margin-right: 30px;  border-radius: 10px; text-align: center;
    cursor: pointer;color:#666;
      img{width: auto;height: 40px;}
      .imgDes{display: block;font-size: 12px;}

    }
    .tagOneItem:hover{border:1px solid #aaa;color:#000;}
    .tagOneItem.active{border:1px solid skyblue;background: cadetblue;color:#fff;}
    .inlineBlock{display: inline-block;}
    .nameSpan{display: inline-block;margin-right: 5px;font-weight: bold;margin-bottom: 5px;}


    .detail{
      .tagOneItem{border:red}
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/tagSelect.vue